// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2MYfG","buttons":"SendReceipts_buttons__8s4Uf","email":"SendReceipts_email__IOA46","bookApptTitle":"SendReceipts_bookApptTitle__3CrTa"};